<!-- 供水监控 -->
<template>
    <div class="m-panel">
      <div class="m-panel-bar">
        <div class="m-panel-bar-title">
          {{title}}
        </div>
      </div>
      <div class="m-panel-body">
        <div class="box">
            <div class="box-content">
                <div class="box-item">
                    <!-- <div class="box-item-content-image1">
                    </div> -->
                    <div class="box-item-content-body">
                        <span>{{totalWater}}</span> m³
                    </div>
                    <div class="box-item-content-title">
                        {{ $t('年供水流量') }}
                    </div>
                </div>
                <div class="box-item">
                    <!-- <div class="box-item-content-image2">
                    </div> -->
                    <div class="box-item-content-body">
                        <span>{{todayWater}}</span> m³
                    </div>
                    <div class="box-item-content-title">
                        {{ $t('今日供水量') }}
                    </div>
                </div>
                <div class="box-item">
                    <!-- <div class="box-item-content-image2">
                    </div> -->
                    <div class="box-item-content-body">
                        <span>{{pressure}}</span> MPa
                    </div>
                    <div class="box-item-content-title">
                        {{ $t('出水压力') }}
                    </div>
                </div>
                <div class="box-item">
                    <!-- <div class="box-item-content-image2">
                    </div> -->
                    <div class="box-item-content-body">
                        <span>{{currentWater}}</span> m³/h
                    </div>
                    <div class="box-item-content-title">
                        {{ $t('瞬时流速') }}
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </template>
  <script>
    // import {
    //   getAction,
    //   postAction
    // } from '@/api/manage'
    export default {
      props: {
        titleImage: {
          type: String,
          default: ''
        },
      },
      data() {
        return {
          title: this.$t('供水监控'),
          url: {},
          totalWater: 23456,
          todayWater: 66,
          currentWater: 123,
          pressure: 2.34
        }
      },
      mounted() {},
      methods: {
        init() {},
        }
    }
  </script>
  <style lang="less" scoped>
    .tabs {
      display: flex;
      position: absolute;
      right: 0;
    }
  
    .tab {
      padding: 6px 8px;
      margin: 0 0 0 0;
  
      cursor: pointer;
    }
  
    .tab-active {
      position: relative;
    }
  
    .tab-active::before {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      content: '';
      height: 2px;
      background-color: #019AF3;
      transition: all .3s;
  
    }
  
    .tab:last-child {
  
      margin-right: 0;
    }
  
    .tab-title {
      font-size: 12px;
      font-weight: normal;
      color: #7993b3;
      cursor: pointer;
    }
  
    .tab-active .tab-title {
      color: #cbdff7;
      position: relative;
      font-weight: 500;
    }
  
    .trends-box {}
    .ant-radio-button-wrapper{
      color: #fff;
      background: transparent;
    }
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled){
      color: #1890FF;
    }
    .box{
      height: 100%;
        .box-content{
          height: 100%;
            display: flex;
            justify-content: space-evenly;
            align-items: flex-start;
            flex-wrap: wrap;
            // margin-top: 30px;
            .box-item{
                color: #fff;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                width: 45%;
                height: 45%;
                border: 1px solid #1890FF;
                border-radius: 4px;
                .box-item-content-image1{
                    background: url('~@/assets/images/water-use-total.png') repeat 387px 0;
                    height: 96px;
                    width: 55%;
                    margin-bottom: 30px;
                }
                .box-item-content-image2{
                    background: url('~@/assets/images/water-use-total.png') repeat 186px 0;
                    height: 96px;
                    width: 55%;
                    margin-bottom: 30px;
                }
                .box-item-content-title{
                    font-size: 21px;
                }
                .box-item-content-body{
                    font-size: 18px;
                    span{
                      font-family: 'ds-digital-bold';
                      font-size: 35px;
                    }
                }
            }
        }
    }
  </style>